


import { Component, ViewChild, EventEmitter, Output, Input, OnInit, OnDestroy ,OnChanges,SimpleChanges} from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ControparteAssociativaAdapter } from 'src/app/common/components/fascicolo/controparti-associativa-update/controparte-associativa-adapter';
import { BaseForm } from 'src/app/common/form/base-Form';
import { ContropartiPrecedentiAddComponent } from 'src/app/common/form/controparti-precedenti-add/controparti-precedenti-add.component';
import { Controparte } from 'src/app/common/models/controparte';
import { Parte } from 'src/app/common/models/parte';
import { Categoria } from 'src/app/common/models/tipologiche/categoria';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { OperationsService } from 'src/app/core/services/operations.service';
import { CreazionePraticaStoreService } from '../../../services/creazione-pratica-store.service';
import { Anagrafica } from 'src/app/common/models/anagrafica';
import { CreazionePraticaTipologicheService } from '../../../services/creazione-pratica-tipologiche.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-associazione-controparte-form',
  templateUrl: './associazione-controparte-form.component.html',
  styleUrls: ['./associazione-controparte-form.component.css']
})
export class AssociazioneControparteFormComponent extends BaseForm implements OnInit,OnChanges, OnDestroy {

  @Input() primariaPreselected: boolean;

  @Input() position: any;

  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input() controparte: Controparte;
  @Input() parte: Parte;
  @Input() suggestedCategory: string | null;
  @Input() suggestedSubjectType: string | null;
  associativaForm: FormGroup;
  tipicategoriaOptions: Categoria[] = [];
  genericFascicolo: string;
  flagAttore: boolean;

  componentDestroyed$: Subject<void> = new Subject<void>();

  @Output()
  onReturn: EventEmitter<Controparte> = new EventEmitter<Controparte>()

  constructor(private campiForm: FormBuilder,
    protected operationService: OperationsService,
    private tipologicheService: CreazionePraticaTipologicheService,
    private creazionePraticaStoreService: CreazionePraticaStoreService) {
    super()

  }

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.controparte){
      if(this.primariaPreselected){
        this.controparte.primario = true;
      } else {
        this.controparte.primario = false;
      }
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }



  createForm() {
    this.populateSelect()
    if (!this.controparte) {
      this.controparte = new Controparte();
    }
    let controparte =  this.controparte;

    if(this.primariaPreselected){
      this.controparte.primario = true;
    } else {
      this.controparte.primario = false;
    }
    if (this.parte) {
      controparte.parte = this.parte;
    }
    this.controparte = new ControparteAssociativaAdapter(controparte).controparte;
    if (this.inserimento) {
      this.controparte.flagAttore = false;
    }
    if (!this.controparte.dataAssociazione) {
      this.controparte.dataAssociazione = new Date().getTime();
    }
    if(this.suggestedSubjectType) {
      this.controparte.flagAttore = this.suggestedSubjectType === 'ATTORE' ? true : false;
      this.flagAttore = true;
    }
    if (this.suggestedCategory && this.tipicategoriaOptions.length > 0) {
      this.controparte.categoria = this.tipicategoriaOptions.filter(categoria =>
        categoria.label === this.suggestedCategory
      )[0];
    }

    this.associativaForm = this.campiForm.group({
      primario: [this.controparte.primario],
      categoria: [this.controparte.categoria],
      // dataAssociazione: [this.formControparte.dataAssociazione, Validators.required],
      ritirato: [this.controparte.ritirato],
      cliente: [this.controparte.cliente],
      dataTermine: [this.controparte.dataTermine],
      note: [this.controparte.note],
      flagAttore: [this.controparte.flagAttore]
    });
  }

  populateSelect() {
    if (this.tipicategoriaOptions.length === 0) {
      let tipoFascicolo = this.creazionePraticaStoreService.getTipoFascicolo();
      if (tipoFascicolo) {
        this.genericFascicolo = tipoFascicolo.endpoint.toLowerCase();
      }
      this.tipologicheService.getCategorieControparte(this.genericFascicolo).pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
        this.tipicategoriaOptions = response;
        if (this.controparte && this.suggestedCategory && this.tipicategoriaOptions.length > 0) {
          this.controparte.categoria = this.tipicategoriaOptions.filter(categoria =>
            categoria.label === this.suggestedCategory
          )[0];
        }
      });
    }
  }

  update() {
    console.log('submit')
    this.onReturn.emit(this.controparte)
  }

  changeFlag(){
    this.flagAttore = !this.flagAttore;
  }

  /*   abstract getControparte(): Controparte;
    abstract getRequest(request: Controparte);
    canCheckPrimary(): boolean; */

}
